import { useOutletContext } from 'react-router-dom'

import { TrainingsSession } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import { UploadCertificate } from 'modules/trainings/components/MyTrainings/UploadCertificate'

const EmployeeSessionModalUploadCertificateModal = () => {
  const { navigation } = useNavigation()
  const { employeeId, employeeAccessId, trainingId, session } = useOutletContext<{
    employeeId: number
    employeeAccessId: number
    trainingId: number
    session: TrainingsSession
  }>()
  return (
    <UploadCertificate
      accessId={employeeAccessId}
      navigateBackTo={navigation.employees.id.training.detail.view.sessionDetail.fullPath({
        id: employeeId,
        trainingId,
        sessionId: session.id,
      })}
    />
  )
}

export default EmployeeSessionModalUploadCertificateModal
